import { Link } from 'react-router-dom'
import { SidebarNav } from './sidebar-nav'
import {
  defaultLandingPathForDesk,
  workspaceDeskSubtitle,
} from '@/config/workspace-desk-routes'
import { resolveWorkspaceDeskFromHost } from '@/config/workspace-desk'
import { useMeSessionQuery } from '@/features/auth/hooks/use-me-session-query'

export function Sidebar() {
  const desk = resolveWorkspaceDeskFromHost(window.location.hostname)
  const session = useMeSessionQuery()
  const subtitle = workspaceDeskSubtitle(desk) ?? 'Recruitment · HR'
  const homePath = defaultLandingPathForDesk(desk, session.data?.roles ?? [])

  return (
    <aside className="flex h-full w-full shrink-0 flex-col bg-surface-sidebar text-text-on-sidebar md:sticky md:top-0 md:h-screen md:w-[272px]">
      {import.meta.env.DEV ? (
        <div
          className="pointer-events-none absolute -left-8 top-3 z-10 origin-center -rotate-45 bg-brand-secondary px-8 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white shadow-sm"
          aria-hidden
        >
          Dev · App
        </div>
      ) : null}

      <Link
        to={homePath}
        aria-label="Workspace home"
        className="flex items-center gap-3 border-b border-white/10 px-4 py-4 outline-none hover:bg-white/5 focus-visible:bg-white/5"
      >
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 text-sm font-bold text-white">
          AM
        </div>
        <div className="min-w-0">
          <p className="truncate text-base font-bold text-white">AM Global</p>
          <p className="truncate text-xs text-text-on-sidebar/80">{subtitle}</p>
        </div>
      </Link>

      <SidebarNav />
    </aside>
  )
}
